import React, {useEffect, useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import Icon, {icons} from './Icons'
import '../css/DriverAge.scss'
import { inputTypes } from '../const'

export default props => {
    const {
        driverType,
        style,
        forceClose,
        setActiveInput,
        inputType,
        onChange,
        textRegularDriver,
        textYoungDriver21,
        textYoungDriver23,
        DriverLeyend
    } = props


    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if(isOpen && forceClose) setIsOpen(false)
    }, [forceClose, isOpen])

    const handleClick = yd => {
        setIsOpen(!isOpen)        
        setActiveInput(isOpen ? inputTypes.none : inputType)
    }


    return (
        <div className="driver-age-container" style={style}>
            <div className="selected-age" onClick={handleClick}>
                <Icon icon={icons.driver} className='icon-input' />
                <div className='driver-age-value' >{driverType == 1 ? textYoungDriver21 : (driverType == 2 ? textYoungDriver23 : textRegularDriver) }</div>
                <FontAwesomeIcon icon='chevron-down' className='icon-input' />
            </div>                        
            
            {isOpen && 
             <div className="selection-ages" >
                 {/* <div className={classNames('selecion-ages-item', isYoungDriver ? 'selected' : '')} onClick={() => onChange(true)}>
                     {textYoungDriver21}
                 </div>
                 <div className={classNames('selecion-ages-item', !isYoungDriver ? 'selected' : '')} onClick={() => onChange(true)}>
                     {textYoungDriver23}
                 </div>
                 {/* <div className={classNames('selecion-ages-item', !isYoungDriver ? 'selected' : '')} onClick={() => onChange(false)}>
                     {textRegularDriver}
                 </div>  */}
                 <div className={classNames('selecion-ages-item', driverType == 1 ? 'selected' : '')} onClick={() => onChange(1)}>
                     {textYoungDriver21}
                 </div>
                 <div className={classNames('selecion-ages-item', driverType == 2 ? 'selected' : '')} onClick={() => onChange(2)}>
                     {textYoungDriver23}
                 </div>
                 <div className={classNames('selecion-ages-item', driverType == 3 ? 'selected' : '')} onClick={() => onChange(3)}>
                     {textRegularDriver}
                 </div>
             </div> 
            }
        </div>
    )
}
